<template>
  <v-container class="pt-10">

    <div v-if="isLoading">
      <v-skeleton-loader
          class="my-2"
          type="list-item-avatar"
          v-for="i in 5"
          :key="i"
      ></v-skeleton-loader>
    </div>

    <Pipelines :pipelines="pipelines"
               @click="onPipelineClick"
               v-else/>

  </v-container>
</template>

<script>
//import axios from 'axios'
import API from '@/api'

import { mapMutations } from 'vuex'

import utility from '@/mixins/utility'

import Pipelines from '@/components/Pipeline/Pipelines'

export default {
  
  name: 'Home',

  mixins: [ utility ],

  components:
  {
    Pipelines
  },

  data: () => ({
    isLoading: false,
    pipelines: []
  }),

  computed:
  {
    
  },

  methods: 
  {
    ...mapMutations({
      setLoading: 'ui/setLoading'
    }),

    load()
    {
      this.isLoading = true

      API.pipeline.user()
                  .then(({ data })=>{
                    this.pipelines = this.mapModels(data.data, 'pipeline')
                  })
                  .finally(()=>this.isLoading=false)
    },

    onPipelineClick(pipeline)
    {
      let params = { id:pipeline.id, pipeline }

      this.goTo({ name:'pipeline', params })
    }
  },

  mounted()
  {
    this.load()
  },

  watch:
  {
    isLoading()
    {
      //this.setLoading(value)
    }
  }

}
</script>
